import * as React from 'react';
import axios from 'axios';
import { Reclamation } from './iMonCompte';
import { renderImgLink } from './RenderCommon';
import { getShopRefInStorage, getUserId } from './MonCompteAction';
import Modal from 'react-responsive-modal';
import { replaceHexadecimalCharacter } from './OrderAction';
import Icons from './Icons';
import { getHostApi, getRequestConfig } from '../../utils';
import RenderChoixEtiquette from './RenderChoixEtiquette';
import { RenderPointsRelais } from './RenderPointsRelais';

interface RenderReclamationDetailsProps{
  reclamation: Reclamation;
  orderId: number;
  refresh: () => boolean;
}

export default class RenderReclamationDetails extends React.Component<RenderReclamationDetailsProps,
  any> {
  constructor(props: RenderReclamationDetailsProps) {
    super(props);
    this.state = {
      showAlert: false,
      textAlert: 'Votre demande de réclamation a bien été annulée',
      classAlert: 'alert-success',
      open: false,
      openPr: false,
      openDetails: false,
    };
  }

  _cancelReclamation = (isTraitee: boolean = false) => {
    this.onCloseModal();
    const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.orderId}/reclamations/${this.props.reclamation.id}`;
    axios.put(url, {isTraitee}, getRequestConfig())
      .then((response) => {
      this.setState({
        showAlert: true,
        textAlert: 'Votre réclamation a bien été annulée !',
        classAlert: 'alert-success',
      }, () => {
        this.props.refresh();
      });
    }).catch((error) => { console.log(error); });
  }

  onOpenModal = () => {
    this.setState({ open: true });
  }

  onCloseModal = () => {
    this.setState({ open: false });
  }

  onOpenModalPr = () => {
    this.setState({ openPr: true });
  }

  onCloseModalPr = () => {
    this.setState({ openPr: false });
  }

  onOpenModalDetails = () => {
    this.setState({ openDetails: true });
  }

  onCloseModalDetails = () => {
    this.setState({ openDetails: false });
  }

  onClickButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    this.onOpenModal();
  }

  _onGenerateColis = () => {
    const transporteurLength = this.props.reclamation.transporteurs.length;
    let response = false;
    let nbrEtiquetteTxt = '1 étiquette';
    let nbrColis = 1;

    if (this.props.reclamation.nb_colis && this.props.reclamation.nb_colis > 1) {
      nbrEtiquetteTxt = this.props.reclamation.nb_colis + ' étiquettes';
      nbrColis = this.props.reclamation.nb_colis;
    }

    if (transporteurLength >= 2 && this.props.reclamation.attente_client == 'Remboursement' &&
      this.props.reclamation.remboursement.fraisTransporteur &&
      this.props.reclamation.remboursement.fraisTransporteur != 0) {
      response = confirm('Confirmez-vous la génération de ' + nbrEtiquetteTxt + ' ' +
        this.props.reclamation.transporteur_name + '  ? \n(Frais de transport déduits de votre remboursement de ' +
        this.props.reclamation.remboursement.fraisTransporteurTTC + '€). ');
    } else if (transporteurLength >= 2 && this.props.reclamation.attente_client == 'Remboursement' &&
      this.props.reclamation.transporteur_id == '3') {
      response = confirm('Confirmez-vous la génération de ' + nbrEtiquetteTxt + ' ' +
        this.props.reclamation.transporteur_name + ' à 0€ ? \n(Pas de frais de transport déduits). ');
    } else if (nbrColis > 1) {
      response = confirm('Confirmez-vous le retour de ' + nbrColis + ' colis ?');
    } else {
      response = confirm('Confirmez-vous le retour de ' + nbrColis + ' colis ? ');
    }
    if (response == true) {
      document.dispatchEvent(new Event('dp-loading'));
      const url = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.orderId}/reclamations/${this.props.reclamation.id}/etiquettes`;

      axios.post(url, { quantity: this.props.reclamation.nb_colis,
        transporteur_id: this.props.reclamation.transporteur_id }, getRequestConfig()).then((response) => {
        document.dispatchEvent(new Event('dp-loaded'));
        const url = response.data.url;

        window.location.href = '/' + url;
      }).catch((error) => {
        document.dispatchEvent(new Event('dp-loaded'));
        console.log(error);
      });
    }
  }

  _onNbColisChanged = (qte: number) => {
    if (qte <= 0 || qte > 5) {
      return;
    }
    this.props.reclamation.nb_colis = qte;
    this.forceUpdate();
  }

  _onTransporteurChanged = (transporteurId: string) => {
    this.props.reclamation.transporteur_id = transporteurId;
    let transporteur = null;

    for (const item of this.props.reclamation.transporteurs) {
      if (item.id == transporteurId) {
        transporteur = item;
      }
    }

    this.props.reclamation.transporteur_name = transporteur?.nom as string;

    if (transporteur && this.props.reclamation.remboursement) {
      const remboursementHt = (this.props.reclamation.remboursement.totalRemboursementHT - transporteur.prix);
      const montantTva = remboursementHt * (this.props.reclamation.remboursement.tauxTva / 100);

      const ttc = remboursementHt + montantTva;
      this.props.reclamation.remboursement.totalRemboursementTTC = parseFloat(ttc as any).toFixed(2);
      this.props.reclamation.remboursement.fraisTransporteur = transporteur.prix;
      this.props.reclamation.remboursement.fraisTransporteurTTC =
        parseFloat((transporteur.prix * (this.props.reclamation.remboursement.tauxTva / 100 + 1)) as any).toFixed(2);
    }
    this.forceUpdate();
    // this.setState({ reclamations: reclamations });
  }

  render() {
    const renderCancelModal = (isTraitee = false) => {
      const hasSavInRetourTraite = !this.props.reclamation.canCancel && this.props.reclamation.statut_id == 90 && this.props.reclamation.commande_sav_id !== null;
      return (
        <Modal open={this.state.open} onClose={this.onCloseModal} center
               classNames={{overlay: 'bootstrap-container', modal: 'cancelClaimModalContainer customModal',
                 closeButton: 'cancelClaimModalCloseButton closeButton'}}>
          <div className="modalOrder p-2 pa0Mobile">
            <p className="text-center bold font18">
              Etes-vous sûr de vouloir annuler la réclamation n° {this.props.reclamation.id} ?
              {hasSavInRetourTraite &&
                <div>                 
                  <div className="my-3 italic grey"> <Icons icon="warning" size={15} color="red"/> La commande SAV correspondant à cette commande doit être annulée avant d'effectuer cette action. Vous prenez la responsabilité de l'impact de votre action sur le système.</div> 
                  <div>Souhaitez-vous poursuivre ?</div>
                </div> 
            }
            </p>
            <button title="Annuler" onClick={this.onCloseModal}
                    className="border-0 bold bg-white1 cursor-pointer btnCancelModal float-left py-2 px-3">
              Non
            </button>
            <button title="Annuler la commande" onClick={() => { this._cancelReclamation(isTraitee); }}
                    className="border boder-dark bold bg-white1 cursor-pointer btnValidateModal float-right py-2 px-3">
              Oui
            </button>
          </div>
        </Modal>
      );
    };

    const renderDeleteButton = () => {
      if (this.props.reclamation.annulation_possible) {
        return (
          <div className="pr-1">
            <button title="Annuler la réclamation" onClick={event => this.onClickButton(event)}
                    id={this.props.reclamation.id} className="cursor-pointer border-0 p-0 bg-transparent">
              <Icons icon="delete_address" size={10} color="black" title="Annuler la réclamation"/>
            </button>
            {renderCancelModal()}
          </div>
        );
      }
    };

    const renderNumReclamation = () => {
      return (
        <div>
          <span className="bg-orange p-1 white pt02 pb02">{this.props.reclamation.type}</span>
          <span className="pl-1 small">n°{this.props.reclamation.id}</span>
        </div>
      );
    };

    const renderNumCommande = () => {
      return (
        <div className="">
          <span className="bold big">{this.props.reclamation.num_commande}</span>
        </div>
      );
    };

    const renderCol1 = () => {
      return (
        <div className="col-md-3 pl-0">
          <div className="d-flex">
            {renderDeleteButton()}
            {renderNumReclamation()}
          </div>
          {renderNumCommande()}
        </div>
      );
    };

    const renderAttenteClient = () => {
      return (
        <div>
          Demande de <span className="bold">{this.props.reclamation.attente_client}</span>
        </div>
      );
    };

    const renderNbArticles = () => {
      return (
        <div>
          {this.props.reclamation.nb_articles} article(s) concerné(s) </div>
      );
    };

    const renderCol2 = () => {
      return (
        <div className="col-md-3">
          {renderAttenteClient()}
          {renderNbArticles()}
        </div>
      );
    };

    const renderDateDemande = () => {
      return (
        <div>
          {replaceHexadecimalCharacter(this.props.reclamation.date_demande_fr)}
        </div>
      );
    };

    const renderMotif = () => {
      return (
        <div className="small">
          "{this.props.reclamation.motif}" </div>
      );
    };

    const renderCol3 = () => {
      return (
        <div className="col-md-3 text-center">
          {renderDateDemande()}
          {renderMotif()}
        </div>
      );
    };

    const renderInstructions = () => {
      if (this.props.reclamation.statut_id == '20' && this.props.reclamation.generation_possible == false) {
        return (
          <p className="mb-0 text-center pb-0 mt-2">
            <a className="py-2 px-3 bg-blue small white border-0 d-block cursor-pointer"
               style={{ borderRadius: '30px' }} target={'_blank'}
               href={'/retour-sav/' + this.props.reclamation.numero + '/' + this.props.reclamation.numero + '.pdf'}>
              Télécharger les étiquette(s)
            </a>
          </p>
        );
      }
    };

    const renderModalPr = () => {
      if (this.state.orderId || this.props.orderId) {
        let orderId: any = '';
        if(this.state.orderId) {
          orderId = this.state.orderId;
        } else {
          orderId = this.props.orderId;
        }
        const adresse = this.props.reclamation.addresse_livraison + ' ' + this.props.reclamation.code_postal_livraison +
          ' ' + this.props.reclamation.ville_livraison;
        return (
          <Modal open={this.state.openPr} onClose={this.onCloseModalPr} center
                 classNames={{overlay: 'bootstrap-container', modal: 'pointsRelaisModalContainer customModal',
                   closeButton: 'pointsRelaisModalCloseButton closeButton'}}>
            <div className="modalPR p-2" style={{ maxHeight: '740px' }}>
              <RenderPointsRelais orderId={orderId} defaultAddress={adresse} showButtons={false} retourId={this.props.reclamation?.id}/>
            </div>
          </Modal>
        );
      }
    };

    const renderDetailTransporteur = () => {
      if (this.props.reclamation.transporteur) {
        if (this.props.reclamation.transporteur.id > 1) {
          return (
            <div className="mb-0 mt-2 border pt-2 nobold text-center">
              Retour par : {this.props.reclamation.transporteur.libelle}
              <div className="mt-2 pb-2">
                <a href="#" className="cursor-pointer" onClick={this.onOpenModalPr}>
                  Liste des <span className="text-underline"> points de dépôt</span>
                </a>
                {renderModalPr()}
              </div>
            </div>
          );
        }
      }
    };

    const renderCol4 = () => {
      let statut = this.props.reclamation.statut;
      const isReclamation = this.props.reclamation.type === "Reclamation";
      if (this.props.reclamation.statut_id == '15') {
        statut = 'En attente de justificatifs';
      }
      return (
        <div className="col-md-3 text-center px-0">
          <div className="bold">
            <div className="noBold p-0 small lineheight1 mb-0">Statut de la demande :</div>
            <p className="mb-0 text-center">{statut}</p>
            {renderDetailTransporteur()}
            {renderInstructions()}
            {this.props.reclamation.displayCancelBtn && parseInt(this.props.reclamation.statut_id, 10) === 90 && isReclamation && renderBtnAnnuler()}
          </div>
        </div>
      );
    };

    const renderBtnAnnuler = () => {
      const hasSavInRetourTraite = !this.props.reclamation.canCancel && this.props.reclamation.statut_id == 90 && this.props.reclamation.commande_sav_id !== null;

      const title =  !hasSavInRetourTraite ? "Annuler cette réclamation" : "La commande SAV correspondant à cette commande doit être annulée avant d'effectuer cette action" ;
      return (
        <div className={`mt1 ${!hasSavInRetourTraite ? 'cursor-pointer' : 'cursor-help'}`} title={title}>
            {hasSavInRetourTraite && <Icons icon="warning" size={15} color="red"/>}
            <button className="bg-transparent border-0 text-underline" onClick={event => this.onClickButton(event)}>Annuler</button>
            {renderCancelModal(true)}
        </div>
      );
    }

    const RenderDetailRmbt = () => {
      let detailRemboursement = '';
      let detailRemboursement2 = '';
      let fraisGestion = '';

      if (this.props.reclamation.attente_client == 'Remboursement') {
        if (this.props.reclamation.remboursement.totalRemboursementTTC) {
          detailRemboursement = 'Remboursement prévu de ' +
            this.props.reclamation.remboursement.totalRemboursementTTC.replace('.', ',') + '€ ttc ';
        }
        if (this.props.reclamation.remboursement.fraisTransporteurTTC &&
          this.props.reclamation.remboursement.fraisTransporteurTTC != '0.00') {
          detailRemboursement2 = 'Frais de transport déduits : ' +
            this.props.reclamation.remboursement.fraisTransporteurTTC.replace('.', ',') + '€';
        }
        if (this.props.reclamation.remboursement.fraisGestion &&
          this.props.reclamation.remboursement.fraisGestion != '0.00') {
          fraisGestion = 'Frais de gestion déduits : ' +
            this.props.reclamation.remboursement.fraisGestion.replace('.', ',') + '€';
        }

        return (
          <div className="black bold p-3 pb-0 mb-2">
            {detailRemboursement}
            <div className="nobold">{fraisGestion}</div>
            <div className="nobold">{detailRemboursement2}</div>
          </div>
        );
      }
    };

    const renderGenerateEtiquette = () => {
      if (this.props.reclamation.statut_id == '20' && this.props.reclamation.generation_possible == true) {
        return (
          <div className="mt-2 w-100 text-right lineGenerationEtiquettes">
            <div className="retourLeft w-100">
              <div>
                <RenderChoixEtiquette onTransporteurChanged={id => this._onTransporteurChanged(id)}
                                      transporteurs={this.props.reclamation.transporteurs}
                                      retourId={this.props.reclamation.id}
                                      orderId={this.props.orderId}/>
              </div>
            </div>
            {RenderDetailRmbt()}
            <div className="p-3 pt-1">
              <span>Nombre de colis à renvoyer :&nbsp;</span>
              <input type="number" className="text-center" value={this.props.reclamation.nb_colis} max={5} min={0} defaultValue={1}
                     onChange={e => this._onNbColisChanged(parseInt(e.target.value, 10))}/>
              <button className="py-2 px-3 bg-blue white border-0 ml-2 cursor-pointer"
                      style={{ borderRadius: '30px' }} onClick={e => this._onGenerateColis()}>
                Générer l'étiquette
              </button>
            </div>
          </div>
        );
      }
    };

    const renderTrackingLinks = () => {
      return this.props.reclamation.trackings
        .filter(tracking => !!tracking.link)
        .map((tracking) => (
            <div key={tracking.numColis}>
              <span></span>
              <a target="_blank" href={tracking.link} className="black"
                 title="Suivre mon colis">
                <Icons icon="local_shipping" size={12} color="black"/>
                &nbsp;{tracking.numColis}
              </a>
            </div>
        )
      );
    };

    const renderAllTrackingLinks = () => {
      if (this.props.reclamation.trackings.length > 0) {
        return (
          <div className="mt-2 w-100 text-right pr-3">
            {renderTrackingLinks()}
          </div>
        );
      }
    };

    const renderDetailsModal = () => {
      return (
        <Modal open={this.state.openDetails} onClose={this.onCloseModalDetails} center
               classNames={{overlay: 'bootstrap-container', modal: 'detailsClaimModalContainer customModal',
                 closeButton: 'detailsClaimModalCloseButton closeButton'}}>
          <div className="modalOrder p-2 pa0Mobile">
            <p className="font20 border-bottom text-center bold">Détails de la réclamation n° {this.props.reclamation.id}</p>
            <div>{renderItemsList()}</div>
            <button title="Fermer" onClick={() => { this.onCloseModalDetails(); }}
                    className="border border-dark bold bg-white cursor-pointer btnValidateModal float-right py-2 px-3">
              OK
            </button>
          </div>
        </Modal>
      );
    };

    const renderTitre = (article: any) => {
      if (getShopRefInStorage() === 'DG') {
        return article.produit.titles.fr;
      }
      return article.produit.Titre;
    }

    const renderItemsList = () => {
      return this.props.reclamation.articles.map((article, index) => {
        return (<div key={`${article.produit.Reference}-${index}`} className="d-flex align-items-center p-2">
          <div className="border p-2 mr-3">
            <img src={renderImgLink(article.links)}/>
          </div>
          <div className="d-flex flex-column">
            <div>
              <span className="bold">{renderTitre(article)}</span>&nbsp;-&nbsp;
              <Icons icon="circle" size={25} color={'#' + article.couleur.code1} />
              &nbsp;{article.couleur.Couleur}
            </div>
            <div>Taille : {article.taille ? article.taille : this.props.reclamation.taille}</div>
            <div>Quantité : {article.quantite}</div>
          </div>
        </div>);
      });
    };

    const renderOpenDetailsModalButton = () => {
      return (
        <div className="w-100 mt-2">
          <div className="d-flex align-items-center cursor-pointer" style={{ width: 'max-content' }}
               onClick={() => this.onOpenModalDetails()}>
            <Icons icon="remove_red_eye" size={15} color="black" />
            <button className="bg-transparent border-0 cursor-pointer">Voir le détail de ma réclamation</button>
          </div>
          {renderDetailsModal()}
        </div>
      );
    };

    const renderReclamation = () => {
      return (
        <div className="d-flex flex-column align-items-center">
          <div className="d-flex flex-row justify-content-between align-items-center col-md-12 p-0 reclamDetail">
            {renderCol1()}
            {renderCol2()}
            {renderCol3()}
            {renderCol4()}
          </div>
          {renderOpenDetailsModalButton()}
          {renderGenerateEtiquette()}
          {renderAllTrackingLinks()}
        </div>
      );
    };

    return renderReclamation();
  }
}
